// src/pages/Contact.tsx
const Contact = () => {
  return (
    <div className="min-h-screen p-6 bg-background">
      <div className="max-w-4xl mx-auto space-y-8">
        <h1 className="text-4xl font-bold tracking-tight">Contact Us</h1>
        <div className="prose prose-invert max-w-none">
          <p>We'd love to hear from you! Here's how you can reach us:</p>
          
          <h2>Email</h2>
          <p>support@screentool.com</p>
          
          <h2>Social Media</h2>
          <p>Follow us on Twitter: @screentool</p>
          
          <h2>Business Hours</h2>
          <p>Monday - Friday: 9:00 AM - 5:00 PM EST</p>
        </div>
      </div>
    </div>
  );
};

export default Contact;